<script setup lang="ts">
import { computed } from "vue";
import type { PlaygroundStatus } from "@/api/types";

const props = defineProps<{ status: PlaygroundStatus | "idle"; label?: string }>();

const COLOURS: Record<string, string> = {
  provisioning: "bg-status-provisioning",
  destroying: "bg-status-destroying",
  ready: "bg-status-ready",
  failed: "bg-status-failed",
  "failed-interrupted": "bg-status-failed",
  idle: "bg-status-idle",
};

const TEXT: Record<string, string> = {
  provisioning: "provisioning",
  destroying: "destroying",
  ready: "ready",
  failed: "failed",
  "failed-interrupted": "failed (interrupted)",
  idle: "idle",
};

const dotClass = computed(() => COLOURS[props.status] ?? COLOURS.idle);
const label = computed(() => props.label ?? TEXT[props.status] ?? props.status);
</script>

<template>
  <span class="inline-flex items-center gap-1.5 text-2xs">
    <!-- Status is never colour-only; label always present (a11y §8). -->
    <span
      :class="[dotClass, 'inline-block h-1.5 w-1.5 rounded-full']"
      aria-hidden="true"
    />
    <span>{{ label }}</span>
  </span>
</template>
